export enum GameOptionsTab {
  SYSTEM,
  INTERFACE,
  GAMEPLAY,
  MISC,
  REMOTE_API,
}
